"use client"

import React, { useState } from "react"
import { TextField, IconButton, InputAdornment } from "@mui/material"
import { Clear as ClearIcon } from "@mui/icons-material"
// Commented out - No longer using Autocomplete or API calls
// import { Autocomplete, CircularProgress, Paper } from "@mui/material"
// import { debounce } from "lodash"
// import { fetchProviders } from "./providers-api"

const ProviderAutocomplete = ({ value, onChange, error, size = "medium", ...props }) => {
  const [inputValue, setInputValue] = useState(value || "")

  // ALL API CALL LOGIC COMMENTED OUT - Now just a simple text input
  // const [options, setOptions] = useState([])
  // const [loading, setLoading] = useState(false)
  // const [hasMore, setHasMore] = useState(true)
  // const [page, setPage] = useState(1)

  // const loadOptions = useCallback(
  //   async (searchTerm = "", pageNum = 1, append = false) => {
  //     if (!searchTerm || searchTerm.trim().length === 0) {
  //       setOptions([])
  //       return
  //     }
  //     if (!hasMore && append) return
  //     setLoading(true)
  //     try {
  //       const response = await fetchProviders({
  //         search: searchTerm.trim(),
  //         page: pageNum,
  //         limit: 20,
  //       })
  //       const newOptions = response.providers || []
  //       const validOptions = newOptions.filter(provider => provider.name && provider.name.trim().length > 0)
  //       setOptions((prev) => (append ? [...prev, ...validOptions] : validOptions))
  //       setHasMore(response.hasMore || false)
  //       setPage(pageNum)
  //     } catch (error) {
  //       console.error("Error loading providers:", error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   },
  //   [hasMore],
  // )

  // const debouncedLoadOptions = useCallback(
  //   debounce((searchTerm) => {
  //     setPage(1)
  //     setHasMore(true)
  //     loadOptions(searchTerm, 1, false)
  //   }, 1200),
  //   [loadOptions],
  // )

  const handleInputChange = (event) => {
    const newValue = event.target.value
    setInputValue(newValue)
    // Pass the text value directly to onChange
    onChange(newValue)
  }

  const handleClear = () => {
    setInputValue("")
    onChange("")
  }

  // Simple TextField - no dropdown, no API calls
  return (
    <TextField
      value={inputValue}
      onChange={handleInputChange}
      placeholder="Enter provider name..."
      variant="outlined"
      fullWidth
      error={error}
      size={size}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 1.5,
          fontSize: "0.8rem",
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#035fcb",
              borderWidth: 1,
            },
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9ca3af",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d1d5db",
          },
          ...(error && {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#d32f2f",
              borderWidth: 1,
            },
          }),
        },
        "& .MuiInputBase-input": {
          fontSize: "0.8rem",
        },
      }}
      InputProps={{
        endAdornment: inputValue && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="Clear provider name"
              onMouseDown={(e) => e.preventDefault()}
              onClick={handleClear}
              sx={{ p: 0.25 }}
            >
              <ClearIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  )
}

export default ProviderAutocomplete